const MOCK_ROWS = [
  {
    itemTitle: "SSC JE Recruitment 2026",
    pagePath: "/job/ssc-je-recruitment-2026",
    pageType: "job_detail",
    examName: "SSC JE 2026",
    organizationName: "Staff Selection Commission",
    applyClicks: 182,
    resultClicks: 0,
    admitCardClicks: 0,
    notificationDownloads: 74,
    officialWebsiteClicks: 22,
    answerKeyClicks: 0,
    syllabusClicks: 18,
    totalCtaClicks: 296,
    lastEventDate: "2026-04-01",
  },
  {
    itemTitle: "RRB NTPC Result 2026",
    pagePath: "/job/rrb-ntpc-result-2026",
    pageType: "result_detail",
    examName: "RRB NTPC 2026",
    organizationName: "Railway Recruitment Board",
    applyClicks: 0,
    resultClicks: 244,
    admitCardClicks: 0,
    notificationDownloads: 16,
    officialWebsiteClicks: 29,
    answerKeyClicks: 0,
    syllabusClicks: 0,
    totalCtaClicks: 289,
    lastEventDate: "2026-04-02",
  },
  {
    itemTitle: "UP Police Admit Card 2026",
    pagePath: "/job/up-police-admit-card-2026",
    pageType: "admit_card_detail",
    examName: "UP Police 2026",
    organizationName: "UPPRPB",
    applyClicks: 0,
    resultClicks: 0,
    admitCardClicks: 213,
    notificationDownloads: 12,
    officialWebsiteClicks: 11,
    answerKeyClicks: 0,
    syllabusClicks: 0,
    totalCtaClicks: 236,
    lastEventDate: "2026-03-30",
  },
  {
    itemTitle: "BPSC Teacher Notification 2026",
    pagePath: "/job/bpsc-teacher-notification-2026",
    pageType: "job_detail",
    examName: "BPSC Teacher 2026",
    organizationName: "BPSC",
    applyClicks: 98,
    resultClicks: 0,
    admitCardClicks: 0,
    notificationDownloads: 141,
    officialWebsiteClicks: 19,
    answerKeyClicks: 0,
    syllabusClicks: 9,
    totalCtaClicks: 267,
    lastEventDate: "2026-03-28",
  },
  {
    itemTitle: "SSC GD Answer Key 2026",
    pagePath: "/job/ssc-gd-answer-key-2026",
    pageType: "job_detail",
    examName: "SSC GD 2026",
    organizationName: "Staff Selection Commission",
    applyClicks: 0,
    resultClicks: 0,
    admitCardClicks: 0,
    notificationDownloads: 0,
    officialWebsiteClicks: 13,
    answerKeyClicks: 154,
    syllabusClicks: 0,
    totalCtaClicks: 167,
    lastEventDate: "2026-03-25",
  },
  {
    itemTitle: "IBPS Clerk Syllabus 2026",
    pagePath: "/job/ibps-clerk-syllabus-2026",
    pageType: "exam_page",
    examName: "IBPS Clerk 2026",
    organizationName: "IBPS",
    applyClicks: 0,
    resultClicks: 0,
    admitCardClicks: 0,
    notificationDownloads: 0,
    officialWebsiteClicks: 6,
    answerKeyClicks: 0,
    syllabusClicks: 121,
    totalCtaClicks: 127,
    lastEventDate: "2026-03-24",
  },
  {
    itemTitle: "Railway Group D Recruitment 2026",
    pagePath: "/job/railway-group-d-recruitment-2026",
    pageType: "job_detail",
    examName: "Railway Group D 2026",
    organizationName: "Railway Recruitment Board",
    applyClicks: 161,
    resultClicks: 0,
    admitCardClicks: 0,
    notificationDownloads: 84,
    officialWebsiteClicks: 17,
    answerKeyClicks: 0,
    syllabusClicks: 12,
    totalCtaClicks: 274,
    lastEventDate: "2026-04-03",
  },
  {
    itemTitle: "CTET Result 2026",
    pagePath: "/job/ctet-result-2026",
    pageType: "result_detail",
    examName: "CTET 2026",
    organizationName: "CBSE",
    applyClicks: 0,
    resultClicks: 176,
    admitCardClicks: 0,
    notificationDownloads: 9,
    officialWebsiteClicks: 20,
    answerKeyClicks: 0,
    syllabusClicks: 0,
    totalCtaClicks: 205,
    lastEventDate: "2026-04-04",
  },
];

const EVENT_KEY_TO_RESPONSE_KEY = {
  applyClicks: "topApplyPages",
  resultClicks: "topResultPages",
  admitCardClicks: "topAdmitCardPages",
  notificationDownloads: "topNotificationPages",
};

const toDateOnly = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};

const matchesSearch = (row, searchTerm) => {
  if (!searchTerm) return true;
  const haystack = `${row.itemTitle} ${row.pagePath} ${row.examName} ${row.organizationName}`.toLowerCase();
  return haystack.includes(String(searchTerm).trim().toLowerCase());
};

const matchesDateRange = (row, dateFrom, dateTo) => {
  const dateValue = toDateOnly(row.lastEventDate);
  if (!dateValue) return false;
  if (dateFrom && dateValue < dateFrom) return false;
  if (dateTo && dateValue > dateTo) return false;
  return true;
};

const filterRows = (rows, filters = {}) => {
  const { dateFrom = "", dateTo = "", pageType = "", eventType = "", searchTerm = "" } = filters;

  return rows.filter((row) => {
    if (!matchesSearch(row, searchTerm)) return false;
    if (pageType && row.pageType !== pageType) return false;
    if ((dateFrom || dateTo) && !matchesDateRange(row, dateFrom, dateTo)) return false;
    if (eventType && Number(row[eventType] || 0) <= 0) return false;
    return true;
  });
};

const mapTopRows = (rows, key) =>
  rows
    .filter((row) => Number(row[key] || 0) > 0)
    .sort((left, right) => Number(right[key] || 0) - Number(left[key] || 0))
    .slice(0, 10)
    .map((row, index) => ({
      rank: index + 1,
      itemTitle: row.itemTitle,
      pagePath: row.pagePath,
      pageType: row.pageType,
      totalClicks: Number(row[key] || 0),
    }));

const buildSummary = (rows) => ({
  totalCtaClicks: rows.reduce((sum, row) => sum + Number(row.totalCtaClicks || 0), 0),
  totalApplyClicks: rows.reduce((sum, row) => sum + Number(row.applyClicks || 0), 0),
  totalResultClicks: rows.reduce((sum, row) => sum + Number(row.resultClicks || 0), 0),
  totalAdmitCardClicks: rows.reduce((sum, row) => sum + Number(row.admitCardClicks || 0), 0),
  totalNotificationDownloads: rows.reduce(
    (sum, row) => sum + Number(row.notificationDownloads || 0),
    0
  ),
  topPerformingPage: rows
    .slice()
    .sort((left, right) => Number(right.totalCtaClicks || 0) - Number(left.totalCtaClicks || 0))[0]
    ?.itemTitle || "",
  topPerformingPageType: rows
    .reduce((acc, row) => {
      acc[row.pageType] = (acc[row.pageType] || 0) + Number(row.totalCtaClicks || 0);
      return acc;
    }, {}) || {},
});

const resolveTopPerformingPageType = (summary) =>
  Object.entries(summary.topPerformingPageType || {}).sort((left, right) => right[1] - left[1])[0]?.[0] || "";

export const adminAnalyticsService = {
  async getDashboard(filters = {}) {
    // TODO: replace mock adapter with backend/GA4 aggregated analytics endpoint when available.
    const filteredRows = filterRows(MOCK_ROWS, filters);
    const summary = buildSummary(filteredRows);

    return {
      summary: {
        totalCtaClicks: summary.totalCtaClicks,
        totalApplyClicks: summary.totalApplyClicks,
        totalResultClicks: summary.totalResultClicks,
        totalAdmitCardClicks: summary.totalAdmitCardClicks,
        totalNotificationDownloads: summary.totalNotificationDownloads,
        topPerformingPage: summary.topPerformingPage,
        topPerformingPageType: resolveTopPerformingPageType(summary),
      },
      topApplyPages: mapTopRows(filteredRows, "applyClicks"),
      topResultPages: mapTopRows(filteredRows, "resultClicks"),
      topAdmitCardPages: mapTopRows(filteredRows, "admitCardClicks"),
      topNotificationPages: mapTopRows(filteredRows, "notificationDownloads"),
      combinedPerformance: filteredRows
        .slice()
        .sort((left, right) => Number(right.totalCtaClicks || 0) - Number(left.totalCtaClicks || 0)),
      meta: {
        availableEventTypes: Object.keys(EVENT_KEY_TO_RESPONSE_KEY),
        appliedFilters: filters,
        source: "mock",
        generatedAt: new Date().toISOString(),
      },
    };
  },
};
